<template lang="pug">
  .sign-col-one.g-flex
    .sign-col-one-content.g-flex.g-justify-center
      figure.sign-logo.text-xs-center(v-if="$vuetify.breakpoint.mdAndUp")
        router-link(target="_self" :to="'/'")
          img(:src="logo" :srcset="logo" alt="Logo")
      GuideOnboarding
</template>

<script>
import GuideOnboarding from '@/components/login/GuideOnboarding'

export default {
  props: [
    'logo'
  ],
  components: {
    GuideOnboarding
  }
}
</script>

<style>
.sign-col-one {
  background-image: url('../../assets/login/familia.jpg');
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}

.sign-logo {
  margin-top: 40px;
  margin-left: 40px;
  top: 15px;
}
.sign-logo img {
  height: 36px;
}

@media screen and (max-width: 1024px) {
  .sign-col-one {
    height: 300px;
  }
}

@media screen and (min-width: 600px) {
  .sign-col-one {
    background-position-y: 20%;
    height: 350px;
  }
}

@media screen and (min-width: 1024px) {
  .sign-col-one {
    background-position: center;
  }

  .sign-col-one {
    min-height: 670px;
    height: 100vh;
    width: 50%;
  }

  .sign-col-one-content {
    align-items: flex-start;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/Cover.vue